export default "__VITE_ASSET__63dd6cb9__"